module.exports = __webpack_public_path__ + "static/media/user_new.ded8b2fb.png";